const errorParser = (err) => {
  const { data } = err
  if (!data) {
    return {}
  }
  const { statusCode, errors } = data

  let messages = []
  if (errors) {
    messages = errors.map((error) => error.message)
  } else {
    // messages = ['문제가 발생했어요. (동일 현상이 반복 될 경우 고객센터로 문의해주세요.)']
    messages = data?.message
      ? [data?.message]
      : ['문제가 발생했어요. (동일 현상이 반복 될 경우 고객센터로 문의해주세요.)']
  }

  const message = messages[0]

  return {
    message,
    messages,
    statusCode,
    errors,
  }
}

export const setError = (err) => {
  const msg = errorParser(err)
  const newErr = { ...err, ...msg }
  return newErr
}

export default { setError }
